import type { ChatCreateSchema } from '@repo/schemas/chat/chatCreate';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { ChatService } from './chatService';
import { ChatKey } from './keys';

export function useCreateChat() {
  const queryClient = useQueryClient();
  const createChatMutation = useMutation({
    mutationFn: (data: ChatCreateSchema) => ChatService.createChat(data).then((response) => response.data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [ChatKey.CHAT_LAST_CONVERSATIONS_INFINITE],
        exact: false,
      });
    },
  });

  const errorMessage = useErrorMessage(createChatMutation.error);

  return { ...createChatMutation, errorMessage };
}
